import classNames from 'classnames';
import styles from './status.module.css';

const GREEN = '#1DB678';
const RED = '#F5222D';
const BLUE = '#4096FF';
const ORANGE = '#F9AB00';

const mapperColor = (status: string): string => {
  const statusLC = status.toLocaleLowerCase();

  switch (statusLC) {
    case 'approved':
    case 'leave approved':
    case 'salary ready':
    case 'salary & ticket ready':
    case 'collected':
    case 'issued':
    case 'resumption approved':
    case 'ta mapping pending':
    case 'issued to employee':
    case 'email configured':
    case 'user-created':
      return GREEN;
    case 'rejected':
    case 'cancelled':
    case 'declined':
    case 'cancel':
      return RED;
    case 'open':
      return BLUE;
    default: // pending states which start from 'Awaiting From'
      return ORANGE;
  }
};

const Status: React.FC<{ text: string; className?: string }> = ({
  text,
  className,
}) => {
  if (!text?.length) return null;
  return (
    <div className={styles.status}>
      <div>
        <div
          className={styles.circle}
          style={{ backgroundColor: mapperColor(text) }}
        />
      </div>
      <div className={classNames(styles.textEllips, className)} title={text}>
        {text}
      </div>
    </div>
  );
};

export default Status;
